import React, { useEffect, useState } from 'react'
import {
  //CAvatar,
  //CButton,
  //CButtonGroup,
  CCard,
  CCardBody,
  //CCardImage,
  CCardTitle,
  CCardText,
  //CCardFooter,
  //CCardHeader,
  CCol,
  //CProgress,
  //CRow,
  //CTable,
  CFormSwitch,
  CImage,
} from '@coreui/react'
import apiClient from '../../services/apiClient'
import { buildApiUrl } from '../../utils/getConfiguration'
//import { getStyle } from '@coreui/utils'
//import { CChartBar, CChartLine } from '@coreui/react-chartjs'
//import CIcon from '@coreui/icons-react'
//import { cilArrowBottom, cilArrowTop, cilOptions } from '@coreui/icons'
//import { useNavigate } from 'react-router-dom'
//import devicePic1 from 'src/assets/devices/house.jpg'
//import devicePic2 from 'src/assets/devices/flat.jpg'

const WidgetsReminderConfig = () => {
  const [recommendations, setRecommendations] = useState([])

  const fetchRecommendationsData = async () => {
    try {
      const response = await apiClient.get(buildApiUrl('aois'))
      //const response = await apiClient.get('https://jsonplaceholder.typicode.com/users')
      setRecommendations(response.data)
    } catch (error) {
      console.error('Error fetching recommendations', error)
    }
  }

  useEffect(() => {
    fetchRecommendationsData()
  }, [])

  //let navigate = useNavigate()

  return (
    <div className="small text-medium-emphasis">
      {recommendations.length > 0 && (
        <div className="small text-medium-emphasis">
          {recommendations.map((recommendation) => (
            <CCard key={recommendation.reminder_ID}>
              {/*<CCard key={recommendation.id}>*/}
              <CCardBody>
                <CCol>
                  <CCardTitle>
                    <CImage
                      rounded
                      orientation="top"
                      src={recommendation.pic}
                      width={50}
                      height={50}
                    />
                    <CFormSwitch
                      size="xl"
                      label={recommendation.Title}
                      //label={recommendation.name}
                      id="formSwitchCheckDefaultXL"
                      style={{ height: '48px' }}
                      defaultChecked
                      onClick={() => {
                        //localStorage.removeItem('loginName1')
                        //localStorage.removeItem('wizard')
                        console.log('Clicked')
                        //navigate('/dashboard')
                      }}
                    />
                  </CCardTitle>
                  <CCardText>{recommendation.Description}</CCardText>
                </CCol>
              </CCardBody>
            </CCard>
          ))}
        </div>
      )}
    </div>
  )
}

export default WidgetsReminderConfig
